import { breakpoints, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const ExtraTableHeader = styled.tr`
  td {
    color: var(--text-soft);
    ${typographyV2.bodyXs};
    padding: 6px 0 0;
    border-bottom: none;
  }
`;

export const TableHeaderRow = styled.tr`
  th {
    @media ${breakpoints.lg} {
      padding: 6px 12px 12px;
    }
  }
`;
